import {
  Close,
  Content,
  Description,
  Overlay,
  Portal,
  Root,
  Title,
  Trigger
} from "../../../chunk-VXS6VZEN.mjs";
import "../../../chunk-YNII5Y6F.mjs";
import "../../../chunk-RRWBFD4V.mjs";
import "../../../chunk-HFXIPTW6.mjs";
import "../../../chunk-4U6MH43A.mjs";
import "../../../chunk-OPCIACWD.mjs";
import "../../../chunk-GYRZVAMU.mjs";
import "../../../chunk-QOCR4XUU.mjs";
import "../../../chunk-D6QHF2UO.mjs";
import "../../../chunk-7TMHQ6XO.mjs";
import "../../../chunk-BQ72SK4G.mjs";
import "../../../chunk-FBWCVJGC.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/Dialog/Dialog.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function cls(...parts) {
  return parts.filter(Boolean).join(" ");
}
var IS_DEV = process.env.NODE_ENV !== "production";
function hasBareDialogChildren(children) {
  const isSlot = (child) => child.type === DialogHeader || child.type === DialogBody || child.type === DialogFooter;
  const childrenOf = (child) => child.props.children;
  const isBare = (node) => {
    if (!React.isValidElement(node)) return true;
    if (isSlot(node)) return false;
    const wrapped = React.Children.toArray(childrenOf(node));
    return wrapped.length === 0 || wrapped.some(isBare);
  };
  return React.Children.toArray(children).some(isBare);
}
var DialogBusyContext = React.createContext(false);
function Dialog(props) {
  return /* @__PURE__ */ jsx(Root, { ...props });
}
Dialog.displayName = "Dialog";
function DialogTrigger({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx(Trigger, { ref, className: cls("buyscout-dialog__trigger", className), ...props });
}
DialogTrigger.displayName = "DialogTrigger";
function DialogPortal(props) {
  return /* @__PURE__ */ jsx(Portal, { ...props });
}
DialogPortal.displayName = "DialogPortal";
function DialogOverlay({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx(Overlay, { ref, className: cls("buyscout-dialog__overlay", className), ...props });
}
DialogOverlay.displayName = "DialogOverlay";
function DialogContent({
  ref,
  className,
  container,
  fullScreenOnMobile = true,
  dismissOnOutsideClick = false,
  placement = "center",
  busy = false,
  onInteractOutside,
  onEscapeKeyDown,
  children,
  ...props
}) {
  const warnedRef = React.useRef(false);
  const portalContainer = typeof container === "function" ? container() : container ?? void 0;
  if (IS_DEV && !warnedRef.current && hasBareDialogChildren(children)) {
    warnedRef.current = true;
    console.warn(
      "DialogContent has content that is not inside DialogHeader/DialogBody/DialogFooter. Content outside the slots skips the dialog's scroll layout, so long content overflows instead of scrolling. Wrap free-form content in DialogBody."
    );
  }
  return /* @__PURE__ */ jsxs(DialogPortal, { container: portalContainer, children: [
    /* @__PURE__ */ jsx(DialogOverlay, {}),
    /* @__PURE__ */ jsx(
      Content,
      {
        ref,
        className: cls(
          "buyscout-dialog__content",
          placement === "right" && "buyscout-dialog__content--right",
          fullScreenOnMobile && "buyscout-dialog__content--mobile-fullscreen",
          className
        ),
        onInteractOutside: (event) => {
          onInteractOutside?.(event);
          if (busy || !dismissOnOutsideClick) event.preventDefault();
        },
        onEscapeKeyDown: (event) => {
          onEscapeKeyDown?.(event);
          if (busy) event.preventDefault();
        },
        "aria-busy": busy || void 0,
        ...props,
        children: /* @__PURE__ */ jsx(DialogBusyContext, { value: busy, children })
      }
    )
  ] });
}
DialogContent.displayName = "DialogContent";
function DialogHeader({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-dialog__header", className), ...props });
}
DialogHeader.displayName = "DialogHeader";
function DialogBody({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-dialog__body", className), ...props });
}
DialogBody.displayName = "DialogBody";
function DialogFooter({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-dialog__footer", className), ...props });
}
DialogFooter.displayName = "DialogFooter";
function DialogTitle({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx(Title, { ref, className: cls("buyscout-dialog__title", className), ...props });
}
DialogTitle.displayName = "DialogTitle";
function DialogDescription({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx(
    Description,
    {
      ref,
      className: cls("buyscout-dialog__description", className),
      ...props
    }
  );
}
DialogDescription.displayName = "DialogDescription";
function DialogClose({ ref, className, disabled, ...props }) {
  const busy = React.use(DialogBusyContext);
  return /* @__PURE__ */ jsx(Close, { ref, className: cls(className), disabled: busy || disabled, ...props });
}
DialogClose.displayName = "DialogClose";
export {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger
};
//# sourceMappingURL=Dialog.mjs.map